import styled from 'styled-components';
import { colors, fonts } from 'stylesheets';
import bgPass from 'assets/img/pass-icon.png';
import bgError from 'assets/img/icons/error.svg';
import { Button } from 'triider-components';

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const BoxRecovery = styled.div`
  width: 472px;
  height: 576px;
  background: ${colors.white};
  border: 1px solid ${colors.greyLight};
  border-radius: 3px;
  padding: 0px  35px;
  form {
    margin-top: 50px;
  }
`;

export const Icon = styled.div`
  width: 151px;
  height: 144px;
  background: url(${({ isTokenValid }) => (isTokenValid ? bgPass : bgError)})no-repeat;
  background-size: contain;
  margin: 32px auto;
`;

export const Title = styled.p`
  text-align: center;
  font-family: ${fonts.primary};
  color: ${colors.greyDark};
  font-size: 22px;
`;

export const Desc = styled(Title)`
  font-size: 16px;
  padding: 0px 70px;
  margin-bottom: 35px;
`;

export const StyledButtonTriider = styled(Button)`
  height: 44px;
  font: ${fonts.secundary};
  font-weight: bold;
  text-transform: uppercase;
  font-size: 14px;
  margin-top: 75px;
  &:focus,
  &:active {
    outline: none;
    box-shadow: none;
  }
`;
